import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function IllustratedUnlockedIcon(props) {
  return (
    <SvgIcon viewBox="0 0 201 258" {...props}>
      <g clipPath="url(#clip0_1484_88)">
        <path
          d="M163.04 132.92C163.04 149.59 156.49 165.31 144.6 177.2C132.71 189.09 116.98 195.64 100.32 195.64C83.6598 195.64 67.9298 189.09 56.0398 177.2C44.1498 165.31 37.5998 149.58 37.5998 132.92V80.73C37.5998 64.06 44.1498 48.34 56.0398 36.45C67.9298 24.56 83.6598 18.01 100.32 18.01C116.98 18.01 133.81 21.16 145.7 33.05C157.59 44.94 163.04 54.03 163.04 70.7H181.04C181.04 26.29 144.72 0 100.32 0C55.9198 0 19.5898 36.33 19.5898 80.73V132.92C19.5898 177.32 55.9198 213.65 100.32 213.65C144.72 213.65 181.05 177.32 181.05 132.92H163.05H163.04Z"
          fill="#818387"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 117.2V257.63H200.64V106.64L0 117.2Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.23 164.12C119.23 153.67 110.76 145.21 100.32 145.21C89.8802 145.21 81.4102 153.68 81.4102 164.12C81.4102 170.18 84.2701 175.56 88.7001 179.02L81.4102 219.06H119.24L111.95 179.02C116.38 175.56 119.24 170.18 119.24 164.12H119.23Z"
          fill="#1B6100"
        />
      </g>
      <defs>
        <clipPath id="clip0_1484_88">
          <rect width="200.64" height="257.63" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
